import { Color } from "@repo/app-types/constants/colors";
import type { PillColor } from "@repo/ui/Pills/pill";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface InsightsBarProps {
  color: PillColor;
  percentageWidth: number;
  label?: string;
}

const colorToBarColor: Record<PillColor, string> = {
  [Color.Blue]: "bg-blue-400",
  [Color.DarkerBlue]: "bg-blue-700",
  [Color.DarkBlue]: "bg-blue-500",
  [Color.LightBlue]: "bg-blue-300",
  [Color.Green]: "bg-green-400",
  [Color.Red]: "bg-red-400",
  [Color.DarkRed]: "bg-destructive",
  [Color.Yellow]: "bg-yellow-400",
  [Color.Gray]: "bg-gray-400",
  [Color.Lime]: "bg-lime-400",
  [Color.Emerald]: "bg-emerald-400",
  [Color.DarkEmerald]: "bg-emerald-600",
  [Color.Amber]: "bg-amber-400",
  [Color.Orange]: "bg-orange-400",
};

export const InsightBar: FC<InsightsBarProps> = ({
  color,
  percentageWidth,
  label,
}) => {
  const bar = (
    <div className="relative h-1.5 w-full rounded-full bg-gray-200 text-center">
      <div
        className={twMerge(
          "absolute top-0 left-0 h-full rounded-full text-center",
          colorToBarColor[color],
        )}
        style={{
          width: `${percentageWidth}%`,
        }}
      />
    </div>
  );

  if (label) {
    return (
      <div className="w-full">
        <div className="pb-1 text-xs leading-tight">{label}</div>
        {bar}
      </div>
    );
  }

  return bar;
};
